import '../styles/index.scss';
import 'slick-carousel/slick/slick';

import 'bootstrap';
import functions from './functions';
import cart from "./cart";
import popup from "./popup";
import myAccount from "./my-account";
import accordion from "./accordion-panel";
import carousel from "./carousel";
import sidebar from "./sidebar-list";
import quantity from "./quantity-input";
import menu from "./menu";
import AOS from 'aos';
import tooltips from "./tooltips";

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {
            accordion.init();
        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
            functions.cookies();
            cart.init();
            myAccount.init();
            quantity.init();
            carousel.initSliders();
            sidebar.init();
            popup.init();
            menu.initMenu();
            tooltips.tooltips();
            AOS.init();
            $('[data-toggle="tooltip"]').tooltip(
                {
                    html: true
                }
            );
        });
    }

    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }
    onScroll() {
        window.addEventListener('scroll', (event) => {

        });
    }

}

new Main();


